(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/countdown-timer
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @overview Countdown timer core functionality.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("countdown-timer") === undefined) {
    class CountdownTimer extends HTMLElement {
        constructor(){
            super();
            this.targetDate = Date.parse(new Date(this.getAttribute("data-date")));
            if (isNaN(this.targetDate)) return;
            this.initialize();
        }
        initialize() {
            this.days = this.querySelector("[data-days]");
            this.hours = this.querySelector("[data-hours]");
            this.minutes = this.querySelector("[data-minutes]");
            this.seconds = this.querySelector("[data-seconds]");
            this.removeAttribute("hidden");
            this.updateDate();
        }
        updateDate() {
            this.nowDate = new Date();
            this.utcDate = this.nowDate.getTime() + this.nowDate.getTimezoneOffset() * 60000;
            this.diffMilliseconds = this.targetDate - this.utcDate;
            if (Math.sign(this.diffMilliseconds) == "-1") {
                this.newDate(0);
                clearInterval(this.interval);
                return;
            }
            this.newDate(this.diffMilliseconds);
            if (!this.interval) this.interval = setInterval(this.updateDate.bind(this), 1000);
        }
        newDate(diffMilliseconds) {
            this.diffSeconds = Math.ceil(diffMilliseconds / 1000);
            if (this.days) this.days.innerHTML = Math.floor(this.diffSeconds / 86400).toString().padStart(2, "0");
            if (this.hours) this.hours.innerHTML = Math.floor(this.diffSeconds % 86400 / 3600).toString().padStart(2, "0");
            if (this.minutes) this.minutes.innerHTML = Math.floor(this.diffSeconds % 3600 / 60).toString().padStart(2, "0");
            if (this.seconds) this.seconds.innerHTML = Math.floor(this.diffSeconds % 60).toString().padStart(2, "0");
        }
    }
    customElements.define("countdown-timer", CountdownTimer);
}



})();
